var map = {
	"./img_1.jpg": 49039,
	"./img_2.jpg": 37483,
	"./img_3.jpg": 23431,
	"./img_4.jpg": 68238,
	"./img_5.jpg": 98154,
	"./img_6.jpg": 29117,
	"./img_7.jpg": 74128,
	"./img_8.jpg": 89899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26364;